import { Box, Skeleton, Stack } from '@mui/joy';

import { Direction, SkeletonVariant } from 'theme/enums';

const DEFAULT_LEGEND_ITEM_COUNT = 4;

interface IProps {
  height: number | string;
  legendItemCount?: number;
}

export const SkeletonChart = ({ height, legendItemCount = DEFAULT_LEGEND_ITEM_COUNT }: IProps) => {
  return (
    <>
      <Box sx={{ height, marginBottom: 2 }}>
        <Skeleton
          variant={SkeletonVariant.RECTANGULAR}
          sx={{ borderRadius: 1, height: '100%', width: '100%' }}
        />
      </Box>
      <Stack direction={Direction.ROW} sx={{ flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
        {Array.from({ length: legendItemCount }).map((_, i) => (
          <Stack key={i} direction={Direction.ROW} sx={{ alignItems: 'center', gap: 0.75 }}>
            <Skeleton variant={SkeletonVariant.CIRCULAR} sx={{ height: 12, width: 12 }} />
            <Skeleton variant={SkeletonVariant.TEXT} sx={{ height: 16, width: '70px' }} />
          </Stack>
        ))}
      </Stack>
    </>
  );
};
